export class ProductSynopses { 
    public id: string;
    public name: string;
    public description: string;
    public websiteUrl: string;
    public heroImageUrl: string;
    public skus: Array<any>;
    public installPricePerM2Gross: number;
    public bimUrls: Array<string>;
    public datasheetDocumentUrls: Array<string>;
    public epdDocumentUrls: Array<string>;
    public commercialQuoteSku: string;

    constructor({ id, name, description, websiteUrl, heroImageUrl, skus, installPricePerM2Gross, bimUrls, datasheetDocumentUrls, epdDocumentUrls, commercialQuoteSku } : { id: string, name: string, description: string, websiteUrl: string, heroImageUrl?: string, skus?: Array<any>, installPricePerM2Gross?: number, bimUrls?: Array<string>, datasheetDocumentUrls?: Array<string>, epdDocumentUrls?: Array<string>, commercialQuoteSku?: string }) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.websiteUrl = websiteUrl;
        this.heroImageUrl = heroImageUrl;
        this.skus = skus;
        this.installPricePerM2Gross = installPricePerM2Gross;
        this.bimUrls = bimUrls;
        this.datasheetDocumentUrls = datasheetDocumentUrls;
        this.epdDocumentUrls = epdDocumentUrls;
        this.commercialQuoteSku = commercialQuoteSku;
    }
}